import React, { useState, useEffect } from "react";
import Header from "../../components/template/website/Header";
import Footer from "../../components/template/estimate/Footer";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import config from "../../config/config";
import { useForm } from "react-hook-form";
import {
  loadCheckoutScript,
  generatePaymentOrder,
  getEstimateDetails,
  notifyPayment,
} from "../../adapters/payment/payment";
import { useParams } from "react-router-dom";
import {
  getUserInfoFromSession,
  updateCheckOutInfoSession,
} from "../../adapters/session/localSessionAdapter";
import momentTimeZone from "moment-timezone";
import navigationsLinks from "../../constants/navigation_links";
import { isValidPincode } from "../../components/common/validationFn";
import { PaymentSkeleton } from "../../components/skeleton/dashboard/PaymentSkeleteon";
import { ProgressModal } from "../../components/common/ProgressModal";
export function PaymentCheckout(props) {
  const history = useHistory();
  const params = useParams();
  const [paymentType, setPaymentType] = useState("full");
  const [isLoaded, setIsLoaded] = useState(false);
  const [progressModal, setProgressModal] = useState({
    status: false,
    text: "",
  });
  const { register, handleSubmit, errors } = useForm();
  const [estimateData, setEstimateData] = useState(null);
  const fixedTokenAmt = 1500;
  const showMovingOnDate = (date) => {
    const clientTz = momentTimeZone.tz.guess();
    const moveDate = momentTimeZone.utc(date).tz(clientTz);
    return moveDate.format("MMM DD, YYYY hh:mm a");
  };
  const getTotalInvoiceAmt = (estimateData) => {
    const quotes = estimateData["estimate_comparison"];
    const selectedQuote = quotes.filter(
      (quote) => quote["vendor_id"] === params.vendorId
    );
    if (selectedQuote.length > 0) {
      const quote = selectedQuote[0]["quote"];
      return parseFloat(quote.sales_summary["total"]);
    }
    return;
  };

  const closeProgressModal = () => {
    setProgressModal({ status: false, text: "" });
  };

  const submitFn = async (data) => {
    setProgressModal({ status: true, text: "Loading payment gateway..." });
    const from_address = {
      firstName: data["from_customer_name"],
      lastName: "",
      fromAddress: data["from_house_address"],
      fromCity: data["from_city"],
      pincode: data["from_pincode"],
      fromLocality: data["from_locality"],
      fromState: data["from_state"],
    };
    let to_address = {};

    if (estimateData["service_type"] === "relocation") {
      to_address = {
        firstName: data["to_customer_name"],
        lastName: "",
        toAddress: data["to_house_address"],
        toCity: data["to_city"],
        pincode: data["to_pincode"],
        toLocality: data["to_locality"],
        toState: data["to_state"],
      };
    } else if (estimateData["service_type"] === "storage") {
      to_address = estimateData["to_address"];
    }

    const session = getUserInfoFromSession();
    const invoiceAmt = getTotalInvoiceAmt(estimateData);

    const completeInfo = {
      fromAddress: from_address,
      toAddress: to_address,
      propertySize: estimateData["property_size"],
      amount: paymentType === "full" ? invoiceAmt : 1500,
      movingOn: estimateData["moving_on"],
      paymentType: paymentType,
      vendorName: getSelectedQuote(params.vendorId)["business_name"],
    };
    const requestPayload = {
      estimate_id: params.estimateId,
      customer_id: session["userId"],
      vendor_id: params.vendorId,
      from_address: from_address,
      to_address: to_address,
      invoice_amount: invoiceAmt,
      payment_type: paymentType,
      additional_info: null,
      payment_gateway: "razorpay",
    };
    if (paymentType === "token") {
      requestPayload.transaction_amount = 1500;
    } else {
      requestPayload.transaction_amount = invoiceAmt;
    }

    try {
      const response = await generatePaymentOrder(requestPayload);
      if (response.status === 200) {
        if (response.data.meta.code === 200) {
          const gateway_response = response.data.data.gateway_response;
          closeProgressModal();
          razorpay(
            gateway_response,
            parseInt(requestPayload.transaction_amount) * 100,
            completeInfo,
            session
          );
        }
      }
    } catch (e) {
      console.error("An error occurred", e);
    }
  };
  function razorpay(order_id, transaction_amount, completeInfo, session) {
    const phone = session["phone"];
    const name = session["customerName"];
    const email = session["email"];
    const logo = `${config.customerPortal}assets/images/icons/boxigo-icon.png`;
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: transaction_amount,
      currency: "INR",
      name: "Boxigo",
      description: "Payment Transaction",
      image: logo,
      order_id: order_id,
      handler: function (response) {
        response.amount = transaction_amount;
        paymentStatusHandler(response, completeInfo);
      },
      prefill: {
        name: name,
        email: email,
        contact: phone,
      },
      theme: {
        color: "#EE553B",
      },
    };
    const rzp = new window.Razorpay(options);
    rzp.open();
  }
  const paymentStatusHandler = async (response, completeInfo) => {
    setProgressModal({ status: true, text: "Processing payment..." });
    try {
      const res = await notifyPayment(response);
      if (res.status === 200) {
        if (res.data.meta.code === 200 && res.data.meta.status === "OK") {
          updateCheckOutInfoSession(completeInfo);
          closeProgressModal();
          history.push(navigationsLinks.payment_success_page);
        } else {
          closeProgressModal();
          //handle error message.
          console.error("An error occurred", res);
        }
      }
    } catch (e) {
      closeProgressModal();
      //handle error message.
      console.error("An Error occurred", e);
    }
  };

  const getSelectedQuote = (vendorId) => {
    const selectedQuote = estimateData["estimate_comparison"].filter(
      (estimate) => estimate["vendor_id"] === vendorId
    );
    if (selectedQuote.length > 0) {
      return selectedQuote[0];
    }
    return null;
  };

  useEffect(() => {
    const loadData = async () => {
      const load = await loadCheckoutScript();
      const session = getUserInfoFromSession();
      const body = {
        estimate_id: params.estimateId,
        user_id: session["userId"],
        estimate_status: "estimate_by_id",
        vendor_id: params.vendorId,
      };

      const res = await getEstimateDetails(body);
      if (
        res.data.customer_order_details !== null &&
        res.data.customer_order_details !== undefined &&
        load === true
      ) {
        setEstimateData(res.data.customer_order_details);
        setIsLoaded(true);
      } else {
        setIsLoaded(false);
      }
    };
    loadData();
  }, [params]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (estimateData !== null) {
      const status = parseInt(estimateData["estimate_status"]);
      if (status > 3) {
        window.alert("This Order has been already booked");
        history.push(navigationsLinks.dashboard_page);
        return;
      }
    }
  }, [estimateData, history]);
  const validRequired = (value) => {
    return value.trim() === "" ? false : true;
  };
  const JSX = (
    <>
      <Header />
      {isLoaded === false && estimateData === null && <PaymentSkeleton />}
      {isLoaded === true && estimateData !== null && (
        <main className="payment-checkout-container">
          <div className="container my-4">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-8 col-xl-8">
                <h3>Book Your Move Now</h3>
                {/* from address */}
                <form onSubmit={handleSubmit(submitFn)}>
                  <div className="row mt-4">
                    <div className="col-12">
                      <h3 className="mb-3 text-active"> From Address</h3>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-3">
                      <div className="form-group">
                        <label className="form-label">
                          Name <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          defaultValue={
                            estimateData["from_address"]["firstName"]
                          }
                          name="from_customer_name"
                          id="from_customer_name"
                          ref={register({
                            required: true,
                            maxLength: 50,
                            minLength: 3,
                            validate: {
                              validRequired: validRequired,
                              validInput: (address) => {
                                const regex = new RegExp(/^[a-zA-Z .]*$/);
                                return regex.test(address);
                              },
                            },
                          })}
                        />
                      </div>
                      <span className="error error-text">
                        {errors.from_customer_name &&
                          errors.from_customer_name.type === "required" &&
                          "This field is required."}
                        {errors.from_customer_name &&
                          errors.from_customer_name.type === "validInput" &&
                          "Please enter only alphabets."}
                        {errors.from_customer_name &&
                          errors.from_customer_name.type === "validRequired" &&
                          "This field is required."}
                        {errors.from_customer_name &&
                          errors.from_customer_name.type === "maxLength" &&
                          "Maximum characters allowed is 50."}
                        {errors.from_customer_name &&
                          errors.from_customer_name.type === "minLength" &&
                          "Minimum characters required is 3."}
                      </span>
                    </div>
                    <div className="col-sm-12 col-md-9">
                      <div className="form-group">
                        <label className="form-label">
                          House Address <span className="text-danger"> *</span>
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          defaultValue={
                            estimateData["from_address"]["fromAddress"]
                          }
                          name="from_house_address"
                          id="from_house_address"
                          ref={register({
                            required: true,
                            maxLength: 100,
                            minLength: 3,
                            validate: {
                              validAddress: (address) => {
                                const regex = new RegExp(
                                  /^[a-zA-Z 0-9,-@./#\r\n()]*$/
                                );
                                return regex.test(address);
                              },
                              validRequired: validRequired,
                              hasAlphabets: (value) => {
                                const regex = new RegExp(/(.*[a-zA-Z]){3}/i);
                                return regex.test(value);
                              },
                            },
                          })}
                        />
                        <span className="error error-text">
                          {errors.from_house_address &&
                            errors.from_house_address.type === "required" &&
                            "This field is required."}
                          {errors.from_house_address &&
                            errors.from_house_address.type ===
                              "validRequired" &&
                            "This field is required."}
                          {errors.from_house_address &&
                            errors.from_house_address.type === "hasAlphabets" &&
                            "Please enter atleast 3 alphabets."}
                          {errors.from_house_address &&
                            errors.from_house_address.type === "validAddress" &&
                            `Please enter valid address. allowed special characters [/,#,-,@,(,),.]
                              `}
                          {errors.from_house_address &&
                            errors.from_house_address.type === "maxLength" &&
                            "Maximum characters allowed is 100."}
                          {errors.from_house_address &&
                            errors.from_house_address.type === "minLength" &&
                            "Minimum characters required is 3."}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-12">
                      <div className="form-group">
                        <label className="form-label">
                          Locality <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          defaultValue={
                            estimateData["from_address"]["fromLocality"]
                          }
                          className="form-control"
                          name="from_locality"
                          id="from_locality"
                          ref={register({
                            required: true,
                            maxLength: 50,
                            minLength: 3,
                            validate: {
                              validInput: (address) => {
                                const regex = new RegExp(/^[a-zA-Z .]*$/);
                                return regex.test(address);
                              },
                              validRequired: validRequired,
                              hasAlphabets: (value) => {
                                const regex = new RegExp(/(.*[a-zA-Z]){3}/i);
                                return regex.test(value);
                              },
                            },
                          })}
                        />
                        <span className="error error-text">
                          {errors.from_locality &&
                            errors.from_locality.type === "required" &&
                            "This field is required."}
                          {errors.from_locality &&
                            errors.from_locality.type === "validInput" &&
                            "Please enter only alphabets."}
                          {errors.from_locality &&
                            errors.from_locality.type === "hasAlphabets" &&
                            "Please enter atleast 3 alphabets."}
                          {errors.from_locality &&
                            errors.from_locality.type === "validRequired" &&
                            "This field is required."}
                          {errors.from_locality &&
                            errors.from_locality.type === "maxLength" &&
                            "Maximum characters allowed is 50."}
                          {errors.from_locality &&
                            errors.from_locality.type === "minLength" &&
                            "Minimum characters required is 3."}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-4">
                      <div className="form-group">
                        <label className="form-label">
                          From City <span className="text-danger"> *</span>
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          defaultValue={
                            estimateData["from_address"]["fromCity"]
                          }
                          name="from_city"
                          id="from_city"
                          ref={register({
                            required: true,
                            maxLength: 50,
                            minLength: 3,
                            validate: {
                              validRequired: validRequired,
                              validInput: (address) => {
                                const regex = new RegExp(/^[a-zA-Z ]*$/);
                                return regex.test(address);
                              },
                            },
                          })}
                        />
                        <span className="error error-text">
                          {errors.from_city &&
                            errors.from_city.type === "required" &&
                            "This field is required."}
                          {errors.from_city &&
                            errors.from_city.type === "validInput" &&
                            "Please enter only alphabets."}
                          {errors.from_city &&
                            errors.from_city.type === "validRequired" &&
                            "This field is required."}
                          {errors.from_city &&
                            errors.from_city.type === "maxLength" &&
                            "Maximum characters allowed is 50."}
                          {errors.from_city &&
                            errors.from_city.type === "minLength" &&
                            "Minimum characters required is 3."}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-4">
                      <div className="form-group">
                        <label className="form-label">
                          From State <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          defaultValue={
                            estimateData["from_address"]["fromState"]
                          }
                          name="from_state"
                          id="from_state"
                          ref={register({
                            required: true,
                            maxLength: 50,
                            minLength: 3,
                            validate: {
                              validRequired: validRequired,
                              validInput: (address) => {
                                const regex = new RegExp(/^[a-zA-Z ]*$/);
                                return regex.test(address);
                              },
                            },
                          })}
                        />
                        <span className="error error-text">
                          {errors.from_state &&
                            errors.from_state.type === "required" &&
                            "This field is required."}
                          {errors.from_state &&
                            errors.from_state.type === "validInput" &&
                            "Please enter only alphabets."}
                          {errors.from_state &&
                            errors.from_state.type === "validRequired" &&
                            "This field is required."}
                          {errors.from_state &&
                            errors.from_state.type === "maxLength" &&
                            "Maximum characters allowed is 50."}
                          {errors.from_state &&
                            errors.from_state.type === "minLength" &&
                            "Minimum characters required is 3."}
                        </span>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-4">
                      <div className="form-group">
                        <label className="form-label">
                          Pincode <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          defaultValue={estimateData["from_address"]["pincode"]}
                          className="form-control"
                          name="from_pincode"
                          id="from_pincode"
                          ref={register({
                            required: true,
                            validate: { isValidPincode: isValidPincode },
                          })}
                          placeholder="Pincode(Eg: 560034)"
                        />
                        <span className="error error-text">
                          {errors.from_pincode &&
                            errors.from_pincode.type === "required" &&
                            "This field is required."}
                          {errors.from_pincode &&
                            errors.from_pincode.type === "isValidPincode" &&
                            "Please enter a valid 6 digit pincode."}
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* to address */}
                  {estimateData["service_type"] === "relocation" && (
                    <>
                      <div className="row mt-4">
                        <div className="col-12">
                          <h3 className="mb-3 text-active"> To Address</h3>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12 col-md-3">
                          <div className="form-group">
                            <label className="form-label">
                              Name <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="to_customer_name"
                              defaultValue={
                                estimateData["to_address"]["firstName"]
                              }
                              id="to_customer_name"
                              ref={register({
                                required: true,
                                maxLength: 50,
                                minLength: 3,
                                validate: {
                                  validRequired: validRequired,
                                  validInput: (address) => {
                                    const regex = new RegExp(/^[a-zA-Z .]*$/);
                                    return regex.test(address);
                                  },
                                },
                              })}
                            />
                            <span className="error error-text">
                              {errors.to_customer_name &&
                                errors.to_customer_name.type === "required" &&
                                "This field is required."}
                              {errors.to_customer_name &&
                                errors.to_customer_name.type === "validInput" &&
                                "Please enter only alphabets."}
                              {errors.to_customer_name &&
                                errors.to_customer_name.type ===
                                  "validRequired" &&
                                "This field is required."}
                              {errors.to_customer_name &&
                                errors.to_customer_name.type === "maxLength" &&
                                "Maximum characters allowed is 50."}
                              {errors.to_customer_name &&
                                errors.to_customer_name.type === "minLength" &&
                                "Minimum characters required is 3."}
                            </span>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-9">
                          <div className="form-group">
                            <label className="form-label">
                              House Address{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                estimateData["to_address"]["toAddress"]
                              }
                              name="to_house_address"
                              id="to_house_address"
                              ref={register({
                                required: true,
                                maxLength: 100,
                                minLength: 3,
                                validate: {
                                  validAddress: (address) => {
                                    const regex = new RegExp(
                                      /^[a-zA-Z 0-9,-@./#\r\n()]*$/
                                    );
                                    return regex.test(address);
                                  },
                                  validRequired: validRequired,
                                  hasAlphabets: (value) => {
                                    const regex = new RegExp(
                                      /(.*[a-zA-Z]){3}/i
                                    );
                                    return regex.test(value);
                                  },
                                },
                              })}
                            />
                            <span className="error error-text">
                              {errors.to_house_address &&
                                errors.to_house_address.type === "required" &&
                                "This field is required."}
                              {errors.to_house_address &&
                                errors.to_house_address.type ===
                                  "validRequired" &&
                                "This field is required."}
                              {errors.to_house_address &&
                                errors.to_house_address.type ===
                                  "hasAlphabets" &&
                                "Please enter atleast 3 alphabets."}
                              {errors.to_house_address &&
                                errors.to_house_address.type ===
                                  "validAddress" &&
                                `Please enter valid address. allowed special characters [/,#,-,@,(,),.]`}
                              {errors.to_house_address &&
                                errors.to_house_address.type === "maxLength" &&
                                "Maximum characters allowed is 100."}
                              {errors.to_house_address &&
                                errors.to_house_address.type === "minLength" &&
                                "Minimum characters required is 3."}
                            </span>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-12">
                          <div className="form-group">
                            <label className="form-label">
                              Locality <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                estimateData["to_address"]["toLocality"]
                              }
                              name="to_locality"
                              id="to_locality"
                              ref={register({
                                required: true,
                                maxLength: 100,
                                minLength: 3,
                                validate: {
                                  validInput: (address) => {
                                    const regex = new RegExp(/^[a-zA-Z .]*$/);
                                    return regex.test(address);
                                  },
                                  validRequired: validRequired,
                                  hasAlphabets: (value) => {
                                    const regex = new RegExp(
                                      /(.*[a-zA-Z]){3}/i
                                    );
                                    return regex.test(value);
                                  },
                                },
                              })}
                            />
                            <span className="error error-text">
                              {errors.to_locality &&
                                errors.to_locality.type === "required" &&
                                "This field is required."}
                              {errors.to_locality &&
                                errors.to_locality.type === "validInput" &&
                                "Please enter only alphabets."}
                              {errors.to_locality &&
                                errors.to_locality.type === "hasAlphabets" &&
                                "Please enter atleast 3 alphabets."}
                              {errors.to_locality &&
                                errors.to_locality.type === "validRequired" &&
                                "This field is required."}
                              {errors.to_locality &&
                                errors.to_locality.type === "maxLength" &&
                                "Maximum characters allowed is 50."}
                              {errors.to_locality &&
                                errors.to_locality.type === "minLength" &&
                                "Minimum characters required is 3."}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12 col-md-4">
                          <div className="form-group">
                            <label className="form-label">
                              To City <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                estimateData["to_address"]["toCity"]
                              }
                              name="to_city"
                              id="to_city"
                              ref={register({
                                required: true,
                                maxLength: 50,
                                minLength: 3,
                                validate: {
                                  validRequired: validRequired,
                                  validInput: (address) => {
                                    const regex = new RegExp(/^[a-zA-Z ]*$/);
                                    return regex.test(address);
                                  },
                                },
                              })}
                            />
                            <span className="error error-text">
                              {errors.to_city &&
                                errors.to_city.type === "required" &&
                                "This field is required."}
                              {errors.to_city &&
                                errors.to_city.type === "validInput" &&
                                "Please enter only alphabets."}
                              {errors.to_city &&
                                errors.to_city.type === "validRequired" &&
                                "This field is required."}
                              {errors.to_city &&
                                errors.to_city.type === "maxLength" &&
                                "Maximum characters allowed is 50."}
                              {errors.to_city &&
                                errors.to_city.type === "minLength" &&
                                "Minimum characters required is 3."}
                            </span>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-4">
                          <div className="form-group">
                            <label className="form-label">
                              To State <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                estimateData["to_address"]["toState"]
                              }
                              name="to_state"
                              id="to_state"
                              ref={register({
                                required: true,
                                validate: {
                                  validRequired: validRequired,
                                  validInput: (address) => {
                                    const regex = new RegExp(/^[a-zA-Z ]*$/);
                                    return regex.test(address);
                                  },
                                },
                              })}
                            />
                            <span className="error error-text">
                              {errors.to_state &&
                                errors.to_state.type === "required" &&
                                "This field is required."}
                              {errors.to_state &&
                                errors.to_state.type === "validInput" &&
                                "Please enter only alphabets."}
                              {errors.to_state &&
                                errors.to_state.type === "validRequired" &&
                                "This field is required."}
                              {errors.to_state &&
                                errors.to_state.type === "maxLength" &&
                                "Maximum characters allowed is 50."}
                              {errors.to_state &&
                                errors.to_state.type === "minLength" &&
                                "Minimum characters required is 3."}
                            </span>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-4">
                          <div className="form-group">
                            <label className="form-label">
                              Pincode <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                estimateData["to_address"]["pincode"]
                              }
                              name="to_pincode"
                              id="to_pincode"
                              ref={register({
                                required: true,
                                validate: {
                                  isValidPincode: isValidPincode,
                                },
                              })}
                              placeholder="Pincode(Eg: 560034)"
                            />
                            <span className="error error-text">
                              {errors.to_pincode &&
                                errors.to_pincode.type === "required" &&
                                "This field is required."}
                              {errors.to_pincode &&
                                errors.to_pincode.type === "isValidPincode" &&
                                "Please enter a valid 6 digit pincode."}
                            </span>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="row mt-4">
                    <div className="col-12">
                      <h3 className="text-active mb-3">Payment Details</h3>
                      <div className="form-group mb-3">
                        {getTotalInvoiceAmt(estimateData) > fixedTokenAmt && (
                          <div className="custom-control custom-radio">
                            <input
                              type="radio"
                              className="custom-control-input"
                              id="token_payment"
                              name="token_payment"
                              onChange={() => {
                                setPaymentType("token");
                              }}
                              checked={paymentType === "token" ? true : false}
                              value="token_payment"
                            />
                            <label
                              className="custom-control-label payment-type-label"
                              htmlFor="token_payment"
                            >
                              <b> Partial Payment </b> : Pay ₹ {fixedTokenAmt}{" "}
                              /- now to confirm, and balance on{" "}
                              {showMovingOnDate(estimateData["moving_on"])}
                            </label>
                          </div>
                        )}

                        <div className="custom-control custom-radio mb-3">
                          <input
                            type="radio"
                            className="custom-control-input"
                            id="full_payment"
                            name="full_payment"
                            value="full_payment"
                            onChange={() => {
                              setPaymentType("full");
                            }}
                            checked={paymentType === "full" ? true : false}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="full_payment"
                          >
                            <b> Full Payment </b> : Pay ₹{" "}
                            {getTotalInvoiceAmt(estimateData)} /- now
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn btn-dark btn-sm mr-2"
                          onClick={() => {
                            history.push("/dashboard");
                            window.scrollTo(0, 0);
                          }}
                        >
                          <FontAwesomeIcon icon={faChevronLeft} /> Cancel
                        </button>
                        <button className="btn btn-primary btn-sm">
                          Checkout <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <ChargesBreakUp
                  vendorQuote={getSelectedQuote(params.vendorId)}
                />
              </div>
            </div>
          </div>
          <ProgressModal
            isOpen={progressModal.status}
            text={progressModal.text}
            toggle={closeProgressModal}
          />
        </main>
      )}
      <Footer />
    </>
  );
  return JSX;
}

export function ChargesBreakUp(props) {
  const { vendorQuote } = props;
  if (vendorQuote === null) {
    return <></>;
  }
  const quote = vendorQuote["quote"];
  const GST = parseFloat(quote.sales_summary["gst_charge"]).toFixed(2);
  const total = quote.sales_summary["total"];
  const getDiscountAmt = (quote) => {
    if (quote === null) {
      return 0;
    }
    if (quote.sales_summary["discount"] !== undefined || quote.sales_summary["discount"] !== null) {
      return parseFloat(quote.sales_summary["discount"]["amount"]).toFixed(2);
    }
    return 0;
  };
  const discountAmt = getDiscountAmt(quote);
  const chargesList = quote.items;
  const getDiscountLabel = (discount, quote) => {
    return (
      "Discount " +
      (quote.sales_summary["discount"]["type"] === "percentage"
        ? `[${quote.sales_summary["discount"]["value"]}%]`
        : `[₹${discount}]`)
    );
  };
  const JSX = (
    <>
      <div className="charges-container">
        <div className="my-4">
          <div className="row">
            <div className="col-lg-6 d-flex align-items-center">
              <div className="mr-2 border">
                <img
                  src={`${config.mainDomain}vendor-images/${vendorQuote["vendor_id"]}/${vendorQuote["logo"]}`}
                  height="50"
                  width="50"
                  className="border border-dark"
                  style={{ objectFit: "cover" }}
                  alt="..."
                />
              </div>
              <div>
                <div className="payment-label-bold">Mover</div>
                <div className="payment-label">
                  {vendorQuote["business_name"]}
                </div>
              </div>
            </div>
            <div className="col-lg-6 my-4 my-md-0">
              <div className="font-weight-bold text-lg-right">
                No of Days for Delivery
              </div>
              <div className="text-lg-right font-size-sm">
                {vendorQuote["addition_info"]["Days for delivery"]}{" "}
              </div>
            </div>
          </div>
        </div>
        <div className="row my-2">
          <div className="col-sm-12">
            <div className="d-flex justify-content-between mb-2">
              <span className="payment-label-bold">Description</span>
              <span className="payment-label-bold">Amount</span>
            </div>
          </div>
          <div className="col-sm-12">
            {chargesList.map((charge, index) => {
              if (charge.category === "gst_charge") {
                return <></>;
              }
              if (charge.sales_info.amount > 0 || charge.sales_info.description.trim() !== "") {
                return (
                  <div className="d-flex justify-content-between mb-3 border-bottom">
                    <div>
                      <div className="payment-label charge-label">{charge.display_name}</div>
                      <p className="payment-label pb-0 mb-0 charge-description">{charge.sales_info.description}</p>
                    </div>
                    <span className="payment-label charge-amount">
                      ₹ {parseFloat(charge.sales_info.amount).toFixed(2)}
                    </span>
                  </div>
                );
              }
              return <></>;
            })}

            <div className="w-100 d-flex justify-content-between mb-3">
                <div className="payment-label">
                  Sub Total
                </div>
                <span className="payment-label">₹ {parseFloat(quote.sales_summary["sub_total"]).toFixed(2)}</span>
              </div>
            {discountAmt > 0 && (
              <div className="w-100 d-flex justify-content-between mb-3">
                <div className="payment-label">
                  {getDiscountLabel(discountAmt, quote)}{" "}
                </div>
                <span className="payment-label">-₹ {discountAmt}</span>
              </div>
            )}
            {GST >= 0 && (
              <div className="d-flex justify-content-between mb-2">
                <div className="payment-label">
                  {vendorQuote["tax_name"] !== null
                    ? `${vendorQuote["tax_name"]} [${vendorQuote["tax_value"]}%]`
                    : `GST`}{" "}
                </div>
                <span className="payment-label">₹ {GST}</span>
              </div>
            )}

            <div className="d-flex justify-content-between mb-3">
              <div>
                <div>
                  <b>Net Total</b>
                </div>
                <div>(incl. of GST)</div>
              </div>
              <span className="payment-label-bold">₹ {total}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  return JSX;
}
